import axios from './config';

export const getDistributor = (idDistributor) => {
  return axios.get(`/user-distributors/${idDistributor}?populate[0]=contacts_distributor&populate[1]=contacts_distributor.address_contact&populate[2]=contacts_distributor.distributor`).then(res => res.data.data);
};
